import React, { useState, useEffect } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, isWeb } from '@helpers';

import TouchableElement from '@components/common/touchableElement';

import Svg from '@styles/icons/svg';
import { font } from '@styles/fonts';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

export default ({ C, tools: { tools }, getTools, MODES, setMode, setTool, hide, selectToolCloseModal, maxHeight }) => {
  const [filteredTools, setFilteredTools] = useState(tools);
  const [filter, setFilter] = useState('');

  const filterTools = () => {
    if (filter) {
      const newArray = tools.filter((t) => t.toolName.indexOf(filter) > -1 || t.description.indexOf(filter) > -1);
      return newArray;
    }
    return tools;
  };

  useEffect(() => {
    getTools();
  }, []);

  useEffect(() => {
    setFilteredTools(filterTools());
  }, [tools, filter]);

  return (
    <View style={{}}>
      <View>
        <View>
          <View
            style={{
              width: '100%',
              zIndex: 1000,
              height: scale(52),
            }}
          >
            <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
              <TouchableElement
                onPress={() => {
                  selectToolCloseModal ? hide() : setMode(MODES.CLAMPING_TOOL_DETAILS);
                }}
              >
                {({ boxStyle, pressHoverColor }) => (
                  <View style={[boxStyle, { padding: scale(15) }]}>
                    <Text style={[{ color: C(pressHoverColor('System/Light/Blue')) }, font.Body]}>{i18n.t('Cancel')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
            <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
              <TouchableElement onPress={() => setMode(MODES.ADD_TOOL)}>
                {({ boxStyle, pressHoverColor }) => (
                  <View style={[boxStyle, { padding: scale(15) }]}>
                    <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t('New')}</Text>
                  </View>
                )}
              </TouchableElement>
            </View>
          </View>
          <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
            <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Select Tool')}</Text>
          </View>
        </View>
        <View style={{ paddingHorizontal: scale(20) }}>
          <View style={{ width: '100%', marginTop: scale(32) }}>
            <View style={{ position: 'absolute', left: scale(8), top: scale(10), zIndex: 10000 }}>
              <Svg icon="search" color="Label/Light/Tertiary" width={scale(16)} height={scale(16)} />
            </View>
            <TextInput
              style={{
                width: '100%',
                height: scale(36),
                backgroundColor: C('Fill/Light/Quaternary'),
                color: C('Label/Light/Primary'),
                borderRadius: scale(10),
                paddingLeft: scale(31),
                paddingRight: scale(8),
              }}
              placeholderTextColor={C('Label/Light/Tertiary')}
              placeholder={i18n.t('Search')}
              onChangeText={(t) => setFilter(t)}
            />
          </View>
        </View>
      </View>
      <View style={{ paddingTop: scale(39), maxHeight: maxHeight - scale(120) }}>
        <FlashList
          data={filteredTools}
          contentContainerStyle={{ paddingHorizontal: scale(15), paddingBottom: scale(15) }}
          renderItem={({ item: tool, index }) => (
            <TouchableElement
              onPress={() => {
                setTool(tool);
                setMode(MODES.CLAMPING_TOOL_DETAILS);
              }}
              hitSlop={{}}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View>
                  <View
                    style={[
                      boxStyle,
                      {
                        width: '100%',
                        height: scale(52),
                        backgroundColor: C(pressHoverColor(modalFieldBg)),
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingHorizontal: scale(15),
                      },
                      index === 0 && {
                        borderTopLeftRadius: scale(10),
                        borderTopRightRadius: scale(10),
                      },
                      index === filteredTools.length - 1 && {
                        borderBottomLeftRadius: scale(10),
                        borderBottomRightRadius: scale(10),
                      },
                    ]}
                  >
                    <View>
                      <Text style={[{ color: C('Label/Light/Primary') }, font.Body]}>{tool.toolName}</Text>
                      <Text style={[{ color: C('Label/Light/Tertiary') }, font['Caption 1']]}>{tool.description}</Text>
                    </View>
                    <TouchableElement
                      onPress={() => {
                        setTool(tool);
                        setMode(MODES.TOOL_DETAILS);
                      }}
                    >
                      {({ boxStyle }) => (
                        <View style={{ boxStyle }}>
                          <Svg icon="info" color="Link/Light/Primary" width={scale(19)} height={scale(19)} />
                        </View>
                      )}
                    </TouchableElement>
                  </View>
                  {index !== filteredTools.length - 1 && (
                    <View style={{ width: '100%', paddingLeft: scale(15) }}>
                      <View style={{ width: '100%', height: StyleSheet.hairlineWidth, backgroundColor: C('Hairline/Light/No trans') }} />
                    </View>
                  )}
                </View>
              )}
            </TouchableElement>
          )}
          keyExtractor={(item) => item.toolId}
        />
        {!filteredTools.length && (
          <View style={{ height: '100%' }}>
            <Text style={[font.Body, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>{i18n.t('Not found')}</Text>
          </View>
        )}
      </View>
    </View>
  );
};
